export const RPC_URL = "https://mainnet.infura.io/v3/7c58e9ad7df04373961b0ea13277551f"
export const ETH_CONTRACT = "0xa236FFa176bd77a02C5317F1c2EA7Ea897674bff"
export const BSC_CONTRACT = "0xa236FFa176bd77a02C5317F1c2EA7Ea897674bff"
export const ROOT_URL = 'https://backend.blockchain.land'
